var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-button',{attrs:{"size":"small","color":"#3d6b52"},on:{"click":function($event){$event.stopPropagation();return _vm.go.apply(null, arguments)}}},[_vm._v("Encode")])}
var staticRenderFns = []

export { render, staticRenderFns }